import { UsersState } from './state';
import { UsersActionsUnion, UsersActionTypes } from './actions';

export const initialUsersState: UsersState = {
  users: [],
  loaded: false,
  loading: false,
  error: undefined
};

export function usersReducer(
  state: UsersState = initialUsersState,
  action: UsersActionsUnion
): UsersState {
  switch (action.type) {
    case UsersActionTypes.Load:
      return {
        loading: true,
        loaded: false,
        users: [],
        error: undefined
      };
    case UsersActionTypes.LoadSuccess:
      return {
        error: undefined,
        loading: false,
        loaded: true,
        users: action.payload
      };
    case UsersActionTypes.LoadFail:
      return {
        users: [],
        loading: false,
        loaded: false,
        error: action.payload
      };
    default:
      return state;
  }
}
